import { render, staticRenderFns } from "./FormGroupConfig.vue?vue&type=template&id=34c758e4&scoped=true"
import script from "./FormGroupConfig.vue?vue&type=script&lang=js"
export * from "./FormGroupConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c758e4",
  null
  
)

export default component.exports